import moment from 'moment';

export default function sortCommandeAchat(commandes) {
  commandes.sort((a, b) => {
    if (moment(a.datePremierAffichage).isAfter(moment(b.datePremierAffichage))) return 1;
    if (moment(a.datePremierAffichage).isSame(moment(b.datePremierAffichage))) return 0;
    return -1;
  });
}
